import { useGetBusinessDaysQuery } from '../services/benefitApi';
export function useBusinessDays({ competence, enabled = true }) {
    const { data, isLoading, error, refetch } = useGetBusinessDaysQuery({ competence: competence }, {
        skip: !competence || !enabled,
    });
    return {
        businessDays: data?.businessDays ?? null,
        isLoading,
        error: error?.toString() ?? null,
        refetch,
    };
}
